import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import bus from '@/ask/eventBus';
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import typeCargo from '../../../../components/userCenter/public/typeCargo.vue'
import expStartCity from '../../../../components/userCenter/public/expStartCity.vue'
import expDesCountry from '../../../../components/userCenter/public/expDesCountry.vue'
import contraband from '../../../../components/userCenter/public/contraband.vue'
import { Generalcargo } from '@/ask/util'
import { getCookie, delCookie, setCookie } from '@/ask/cookiejs'

export default {
  components: { menberMenu, typeCargo, expStartCity, expDesCountry, contraband },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: "Express Quotes",
      titUrls: "",
      checkIs0Flag: true,
      isReq: 0,//是否显示红色的线提示为空 --- 1：起运城市，2：货好时间 3：目的国家，
      totalShipmentFlag: { flagOne: false, flagTwo: false, flagThree: false },//按总出货量的下的input的空框开关
      tipsMsg: '',//下单类型为包裹，重量输入框提示语
      //仓库
      FromType: 0,
      chkInputOptions: [
        { value: 0, label: 'Factory/warehouse', description: 'if you need us to pick up your goods from your supplier directly' },
        { value: 1, label: 'Freightshop Warehouse', description: 'if your supplier will deliver the goods to Freightshop warehouse' }
      ],

      GoodsReadyTime: new Date(),//货好时间
      datePickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < new Date(new Date()).setDate(new Date().getDate() - 1) || time.getTime() > new Date(new Date()).setDate(new Date().getDate() + 29);
        }
      },

      startCityEn: '', //起运城市英文名
      startCityCh: '', //起运城市中文名
      startCityKey: '', //起运城市Key

      desCountryEn: '', //目的国家英文名
      desCountryKey: '', //目的国家Key

      PacketType: 1,//包裹类型。1：WPX  2:DOC

      QueryType: 2, //按每件计算还是货物重量计算，1：总量计算，2：每件计算
      VolumeUnit: 0,//计算单位 0：厘米，1：英寸
      DocUnit: 0,//计算单位 0：KG，1：LB
      queryDate: '',//存储查价的数据
      //显示总量
      // sumUnit:null,//件数
      //sumKG:null, //KG
      //  sumCBM:null, //CBM
      // sumLB:null,//LB
      // sumCFT:null,//CFT
      //包裹
      //单件计算
      radCargo: [
        {
          Quanlity: null, Long: null, Wide: null, Height: null, Weight: null, isCol1: false, isCol2: false, isCol3: false,
          unitOptions: [
            { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
          ],
          OrderUnit: 1,
        } //isCol== 1:数量为空，2：长宽高为空，3：重量为空
      ],
      //总量信息计算
      unitOptions: [
        { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
      ],
      unitValue: 1,



      //总量计算
      inputUnits: null, //输入件数
      inputWeight: null, //输入重量
      inputCBM: null, //输入总体积

      cargoInfoObj: {}, //特殊货物
      tempCargo: {
        carInfoCh: [],
        cargoID: [],
        cargoInfoEn: []
      }, //临时存储货物（用来传值）
      isGoodsTips: false, //未选择货物种类时提示      
      chkTerms: false,//是否阅读违禁品声明
      showModal: false, //遮罩层
      statement: false, //是否已经阅读违禁品声明
      yzSuccess: false, //下单后为true 验证是否成功  用在从编辑回退时的判断



      //--------查价列表--------//
      //查价头部信息
      goodsInfos: '',//包含货物
      allUnits: '',
      allWeight: '',
      allCBM: '',


      basicInfo: [], //查价列表
      //运输方式
      chkModeCodes: ['DHL', 'UPS', 'FEDEX', 'TNT', 'EMS', 'DPD',"SF"],
      modeCodesItem: [],
      //时效筛选
      ThWorkDayList: [],
      ThWorkDay: [],



      isIndeterminateExp: true,
      transCheckAll: false,

      //分页
      currentPage: 1,//当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数

      isDataNone: false,//是否有渠道数据
      isLoading: false,//加载中...
      isData: true,
      isTable: true,

      //快递列表内容
      isShowCond: true, //上面的条件列表
      isShowList: false, //是否显示列表内容      
      isShowFee: false, //是否显现费用项

      //排序
      orderSort: 'comprehensive',
      showData: 5,//每页显示多少行
      isShowMore: false,//是否显示查看更多

      isShowSel: true, //下单按钮是否给点击下单
      isNormalGood: null,
      wonned: false,//是否选择了木箱
      DAPactived: 0,
      DAPList: [
        {
          lable: "Comprehensive",
          value: 0,
          name: "comprehensive",
        },
        {
          lable: "Cheapest",
          value: 1,
          name: "price",
        },
        {
          lable: "Top-selling",
          value: 2,
          name: "expsale",
        },
        {
          lable: "Quickest",
          value: 3,
          name: "workday",
        },
      ],
      TypeActived: 1,
      TypeList: [
        {
          lable: "DAP express",
          value: 1,
        },
        {
          lable: "DDP service",
          value: 2,
        },
      ],

    };
  },

  created() {
    this.getModeCodesApi();//运输方式接口
  },
  mounted() {
    //如果是从防疫物资专题页面进来的查防疫物资条件，就调用
    if (this.$route.query.zt == 1) {
      this.FromType = 1
      this.GoodsReadyTime = new Date().Format(('yyyy/MM/dd'))
      this.startCityKey = '87928c0a-7344-4124-8abe-305115bdf476'
      this.startCityEn = "Shenzhen"
      this.desCountryKey = this.$route.query.desCountryKey
      this.desCountryEn = this.$route.query.desCountryEn
      this.QueryType = 1
      this.PacketType = 1

      this.VolumeUnit = 0
      this.allUnits = 1
      this.allWeight = this.$route.query.weight
      this.allCBM = null

      this.chkTerms = true

      this.goodsInfos = this.$route.query.cargoNameEn

      this.isShowCond = false
      this.isShowList = true
      this.clkEnEnquiryAPI();

      // this.clkEnEnquiry() //调用查价接口


    } else {
      this.isShowCond = true
      this.isShowList = false
    }
  },
  watch: {
    //起运城市
    startCityKey(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0
      }
    },
    //货好时间
    GoodsReadyTime(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0
      }
    },
    //目的国家
    desCountryKey(newValue, oldValue) {
      if (newValue) {
        this.isReq = 0
      }
    },
    //监听货物种类选择没有
    cargoInfoObj(newValue, oldValue) {
      //console.log('newValuecargoInfoObj ' + JSON.stringify(newValue))
      if (!newValue) {
        this.isGoodsTips = true
      } else {
        this.isGoodsTips = false
      }

    }
  },
  computed: {//计算属性周期函数
    //把选择LB单位，换算成KG,把选择CFT单位，换算成CBM, 
    //sumUnits:'',sumKG:'',sumCBM:'',//总件数、总重量、总体积
    sumUnit() { //件数总计
      let num = 0;
      if (this.radCargo) {
        this.radCargo.forEach(e => {
          num += (Number(e.Quanlity));
        });
        if (isNaN(num)) {
          this.inputUnits = 0;
          return 0;
        }
        if (num === 0) {
          this.inputUnits = null
        }
        else {
          this.inputUnits = num;
        }
      }
      return num;
    },
    //KG单位换算
    sumKG() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            return num += e.Quanlity * e.Weight;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            return num += e.Quanlity * (e.Weight * 0.4535924);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      if (num > 0) {
        this.inputWeight = Number(num).toFixed(3);
      } else {
        this.inputWeight = null;
      }
      // console.log('this.inputWeight ' + this.inputWeight)
      //console.log('num ' + num)
      return num.toFixed(3);
    },
    //磅单位换算
    sumLB() {
      let num = 0;
      //VolumeUnit=0 KG；VolumeUnit=1 LB
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            return (num += e.Quanlity * (e.Weight * 2.2046226));
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            return (num += e.Quanlity * e.Weight);
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }

      return num.toFixed(3);
    },

    //VolumeUnit=0 CBM；VolumeUnit=1 CFT
    //CBM单位换算
    sumCBM() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += ((e.Long * e.Wide * e.Height) / 1000000) * e.Quanlity;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += (((e.Long * 2.54) * (e.Wide * 2.54) * (e.Height * 2.54)) / 1000000) * e.Quanlity;
          });
        }
      }
      if (isNaN(num)) {
        return 0;
      }
      if (num > 0) {
        this.inputCBM = Number(num).toFixed(4);
      } else {
        this.inputCBM = null;
      }
      // console.log('df ' + this.inputCBM)
      return num.toFixed(4);
    },
    sumCFT() {
      let num = 0;
      if (this.VolumeUnit == 0) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += (((e.Long * 0.3937008) * (e.Wide * 0.3937008) * (e.Height * 0.3937008)) / 1000000) * e.Quanlity;
          });
        }
      } else if (this.VolumeUnit == 1) {
        if (this.radCargo) {
          this.radCargo.forEach(e => {
            num += ((e.Long * e.Wide * e.Height) / 1000000) * e.Quanlity;
          });
        }
      }

      if (isNaN(num)) {
        return 0;
      }
      return num.toFixed(4);
    },


    //选择文件时的重量换算
    docWeightKG() {
      if (this.PacketType == 2) {
        if (this.DocUnit == 0) {
          return this.inputWeight
        } else if (this.DocUnit == 1) {
          return (this.inputWeight * 0.4535924).toFixed(3)
        }
      }
    },

    docWeightLB() {
      if (this.PacketType == 2) {
        if (this.DocUnit == 0) {
          return this.inputWeight * 2.2046226
        } else if (this.DocUnit == 1) {
          return this.inputWeight
        }
      }
    },

    //是否显示分页
    isShowpage() {
      let k = false
      if (this.total <= 5 || this.isShowMore == false) {
        k = true
      }
      return k
    }
  },
  methods: {
    TypeCheck(value) {
      this.TypeActived = value;
      //this.PacketType = value
      if (this.TypeActived == 1) {
        // this.chkModeCodes = ["DHL", "UPS", "FEDEX", "TNT", "EMS", "DPD"];
        // this.clkEnEnquiryAPI();
        this.chkModeCodes = this.getModeCodes(value);
        this.clkEnEnquiryAPI();
      } else {
        // this.chkModeCodes = ["LINE", "E-line", "TNT"];
        // this.clkEnEnquiryAPI();
        this.chkModeCodes = this.getModeCodes(value);
        this.clkEnEnquiryAPI();
      }
    },
    getModeCodes(val){
      if(val == 1){
        return ["DHL", "UPS", "FEDEX", "TNT", "EMS", "DPD","SF"]
      }else{
        return ["LINE", "E-line", "TNT"]
      }
    },

    //-------快递查价第一部分条件输入-------------//
    //包裹类型切换，赋值
    clkPacketType(val) {
      this.PacketType = val
      this.inputWeight = null
    },
    //每件计算还是总量计算
    clkQuType(val) {
      this.QueryType = val
      if (this.QueryType == 1) {
        this.radCargo = []
      } else {
        this.radCargo = [
          {
            Quanlity: null, Long: null, Wide: null, Height: null, Weight: null, isCol1: false, isCol2: false, isCol3: false,
            unitOptions: [
              { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
            ],
            OrderUnit: 1,
          }
        ]
      }
    },

    //点击增加图标
    addPackItem() {
      return {
        Quanlity: null, Long: null, Wide: null, Height: null, Weight: null, isCol1: false, isCol2: false, isCol3: false,
        unitOptions: [
          { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden Case' }, { value: 4, label: 'Other' }
        ],
        OrderUnit: 1,
      }
    },
    //货件信息
    addPackage() { //增加包裹
      this.radCargo.push(this.addPackItem())
    },
    delPackage(index) { //删除包裹
      if (this.radCargo.length > 1) {
        this.radCargo.splice(index, 1);
      }
    },
    //input失去焦点时验证
    radCargoBlur(item) {
      if (item.Quanlity) {
        item.isCol1 = false
      }
      if (item.Long && item.Wide && item.Height) {
        item.isCol2 = false
      }
      if (item.Weight) {
        item.isCol3 = false
      }
    },
    //input失去焦点的时候，---Calculate by total shipment选项
    totalShipmentGoBlur(item, index) {
      if (item && index === 1) {
        this.totalShipmentFlag.flagOne = false
      }
      if (item && index === 2) {
        this.totalShipmentFlag.flagTwo = false
      }
      if (item && index === 3) {
        this.totalShipmentFlag.flagThree = false
      }
    },
    checkNumInt(ctrValue) {

      if (ctrValue == 0) {
        ctrValue = '';
      }
      if (ctrValue) {
        ctrValue = ctrValue.replace(/\D/g, '');
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 4) {
          ctrValue = arr[0].substring(0, 4);
        }
      }

      return ctrValue;
    },
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 4);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },
    checkNumFour(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 4) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 5);
          }
        }

        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }

        return ctrValue;
      }
    },
    //起运城市组件取值
    byCityValue(msg) {
      // console.log('msg1  ' + JSON.stringify(msg))
      this.startCityEn = msg.expCityEn
      this.startCityCh = msg.expCityCh
      this.startCityKey = msg.citykey
    },
    //目的国家组件取值
    byCountryValue(msg) {
      // console.log('msg  ' + JSON.stringify(msg))
      this.desCountryEn = msg.expCounEn
      this.desCountryKey = msg.citykey
    },
    //特殊货物取值
    byCargo(msg, isNormalGood) {
      this.isNormalGood = isNormalGood // 是不是选每次 false 为选了，其余为没选
      this.cargoInfoObj = msg
    },
    //违禁品声明
    getClose() {
      this.showModal = false
      this.statement = false
    },
    //点击违禁品声明弹框
    clkContraband() {
      this.$refs.contraRef.clkOpenBox();
    },

    //获取费用计算单位
    conversioUnit(Code) {
      if (Code == 1) return `B\\L`
      if (Code == 2) return 'KG'
      if (Code == 3) return 'Unit'
      if (Code == 4) return 'Pcs'
      if (Code == 5) return '台'
      if (Code == 6) return 'CBM'
      if (Code == 7) return 'Time'
    },

    //列表内容运输方式图标路径
    iconUrl(valName) {
      let url = '';
      if (valName.indexOf('DHL') != -1) {
        url = '../../../static/img/dhl.png'
      } else if (valName.indexOf('UPS') != -1) {
        url = '../../../static/img/ups.png'
      } else if (valName.indexOf('FEDEX') != -1) {
        url = '../../../static/img/fedex.png'
      } else if (valName.indexOf('TNT') != -1) {
        url = '../../../static/img/tnt.png'
      } else if (valName.indexOf('LINE') != -1) {
        url = '../../../static/img/speclalLine.png'
      } else {
        url = '../../../static/img/speclalLine.png'
      }
      return url
    },
    PacketTypeName(code) {
      if (code == 1) return 'Package'
      if (code == 2) return 'Docs'
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    prevClick(val) { //点击上一页
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    nextClick(val) {//点击下一页
      this.currentPage = val;
      this.clkEnEnquiry();
    },
    //上一页最后超出了总页数禁用
    isPrevDisabled() {
      //math.ceil保留小数取整
      if (this.currentPage > 1) {
        return true
      } else {
        return false
      }

      // let totalPage = Math.ceil(this.total / this.pageSize)
      // if (this.currentPage < totalPage) {
      //   // this.isPrevDisabled()
      //   return false
      // } else {
      //   return true
      // }
    },

    //下一页最后超出了总页数禁用
    isNextDisabled() {
      let totalPage = Math.ceil(this.total / this.pageSize)
      if (this.currentPage >= totalPage) {
        // this.isPrevDisabled()
        return false
      } else {
        return true
      }
    },
    //判断是否有数字为0
    checkIs0() {
      if (this.PacketType == 1) {

        this.checkIs0Flag = false
        if (this.QueryType == 1) {
          if (this.inputUnits <= 0 || !Number(this.inputUnits)) {
            this.totalShipmentFlag.flagOne = true
          } else if (this.inputWeight <= 0 || !Number(this.inputWeight)) {
            this.totalShipmentFlag.flagTwo = true
          } else {
            this.totalShipmentFlag.flagOne = false
            this.totalShipmentFlag.flagTwo = false
            this.checkIs0Flag = true
          }
        } else {
          this.radCargo.forEach(e => {
            if (e.Quanlity <= 0 || !Number(e.Quanlity)) {
              e.isCol1 = true
            } else if (e.Long <= 0 || e.Wide <= 0 || e.Height <= 0 || !Number(e.Wide) || !Number(e.Long) || !Number(e.Height)) {
              e.isCol2 = true
            } else if (e.Weight <= 0 || !Number(e.Weight)) {
              e.isCol3 = true
            }
            else {
              e.isCol1 = false
              e.isCol2 = false
              e.isCol3 = false
              this.checkIs0Flag = true
            }
          })
        }
      }
    },


    //查价按钮
    clkEnEnquiry() {
      console.log("=====clkEnEnquiry111",this.TypeActived);
      this.checkIs0(); //检查是否为0
      //起运城市，货好时间，目的国家验证是否为空
      if (!this.startCityKey) {
        this.isReq = 1
        return false;
      }
      if (!this.GoodsReadyTime) {
        this.isReq = 2
        return false;
      }
      if (!this.desCountryKey) {
        this.isReq = 3
        return false;
      }
      //货物种类为包裹的时候验证。
      //单件计算验证是否为空
      if (this.PacketType == 1) {
        if (this.QueryType == 2) {
          let isTrue = true
          this.radCargo.forEach(e => {
            if (!e.Quanlity || !e.Long || !e.Wide || !e.Height || !e.Weight) {
              if (!e.Quanlity) {
                e.isCol1 = true
              } else if (!e.Long || !e.Wide || !e.Height) {
                e.isCol2 = true
              } else if (!e.Weight) {
                e.isCol3 = true
              } else {
                e.isCol1 = false
                e.isCol2 = false
                e.isCol3 = false
                isTrue = true
              }
              isTrue = false
            }
          })
          if (isTrue == false) {
            return false
          }
        }
        if (this.QueryType == 1) {
          let isTrue = true
          if (!this.inputUnits || !this.inputWeight) {
            if (!this.inputUnits) {
              this.totalShipmentFlag.flagOne = true
            } else if (!this.inputWeight) {
              this.totalShipmentFlag.flagTwo = true
            } else {
              this.totalShipmentFlag.flagOne = false
              this.totalShipmentFlag.flagTwo = false
              isTrue = true
            }
            isTrue = false
          }
          if (isTrue == false) {
            return false
          }
        }
        //货物种类不能为空
        if (!this.cargoInfoObj.cargoID || this.cargoInfoObj.cargoID.length < 1) {
          this.isGoodsTips = true;
          return false;
        }
        //验证是否勾选了，已阅禁品申明
        if (this.chkTerms == false) {
          this.showModal = true
          this.statement = true
          return false;
        }
      }
      if (this.PacketType == 1) {
        //this.TypeActived = 1
        ////包含货物信息赋值
        //console.log('this.cargoInfoObj.cargoInfoEn ' + JSON.stringify(this.cargoInfoObj.cargoInfoEn))
        let jsonGoods = this.cargoInfoObj.cargoInfoEn.join(',')
        this.goodsInfos = jsonGoods

        //货物总量赋值
        if (this.QueryType == 2) {
          this.allUnits = this.sumUnit
          this.allWeight = this.sumKG
          this.allCBM = this.sumCBM
        } else if (this.QueryType == 1) {
          if (this.VolumeUnit == 0) {
            this.allUnits = this.inputUnits
            this.allWeight = this.inputWeight
            this.allCBM = this.inputCBM
          } else if (this.VolumeUnit == 1) {
            this.allUnits = this.inputUnits
            this.allWeight = (this.inputWeight * 0.4535924).toFixed(3)
            this.allCBM = (this.inputCBM * 0.0283168).toFixed(4)
          }

        }
      }
      if (this.PacketType == 2) {
        //this.TypeActived = 2
        if (!this.inputWeight) {
          this.tipsMsg = 'Required'
          this.totalShipmentFlag.flagThree = true
          return false;
        } else if (this.inputWeight == 0) {
          this.tipsMsg = 'must be greater than 0'
          this.totalShipmentFlag.flagThree = true
          return false;
        } else {
          this.totalShipmentFlag.flagThree = false
        }

      }
      //便利一下isCol又没有变红
      this.radCargo.forEach(e => {
        if (e.isCol1 || e.isCol2 || e.isCol3) {
          return this.checkIs0Flag = false
        }
      })
      if (this.checkIs0Flag) {
        this.isShowCond = false
        this.isShowList = true
        this.clkEnEnquiryAPI();
      }

      // 调用查价接口
    },
    //查价接口数据
    clkEnEnquiryAPI() {
      let that = this;

      this.api.param = {
        "FromType": this.FromType,
        "GoodsReadyTime": new Date(this.GoodsReadyTime).Format(('yyyy-MM-dd')),
        "StartCityKey": this.startCityKey,
        "CountryKey": this.desCountryKey,
        "QueryType": this.QueryType,
        "PacketType": this.PacketType,//包裹类型 （1：WPX 2:DOC） ,
        "ModeCodes": this.chkModeCodes, //运输方式
        "lstThWorkDays": this.ThWorkDay,
        "ChannelKey": "",
        "OrderBy": this.orderSort,
        "skip": (that.currentPage - 1) * that.pageSize,
        "take": that.pageSize,
        "is_login":true,
        "entrance":"EXPRESS",
        "platform_type":"web",
      }
      this.Iswooned()


      if (this.PacketType == 1) {
        
        //总件数，总体积，总重量
        this.api.param.Quanlity = this.allUnits
        this.api.param.Weight = this.allWeight
        this.api.param.CBM = this.allCBM
        //货物种类，当货物种类为包裹时才传值，文件时不传
        this.tempCargo = JSON.parse(JSON.stringify(this.cargoInfoObj))
        if (this.wonned) {
          this.tempCargo.carInfoCh.push("木箱")
          this.tempCargo.cargoID.push(107)
          this.tempCargo.cargoInfoEn.push("Wooden Case")
        }
        this.api.param.CargoTypeIDs = this.tempCargo.cargoID //货物种类
        if (this.$route.query.zt == 1) {
          this.tempCargo.cargoID = [this.$route.query.cargoId]
          this.tempCargo.carInfoCh = [this.$route.query.cargoNameCH]
          this.tempCargo.cargoInfoEn = [this.$route.query.cargoNameEn]
          this.api.param.CargoTypeIDs = [this.$route.query.cargoId] //货物种类
        }

        //材积信息集合
        if (this.VolumeUnit == 0) {
          this.api.param.GoodInfos = this.radCargo //材积信息集合
        } else if (this.VolumeUnit == 1) {
          //输入In 的时候转换为cm 传回接口
          let radCargobackup = []
          this.radCargo.forEach(e => {
            let radJson = {
              Quanlity: e.Quanlity,
              Long: e.Long * 2.54,
              Wide: e.Wide * 2.54,
              Height: e.Height * 2.54,
              Weight: e.Weight * 0.4535924,
            }
            radCargobackup.push(radJson)
          })
          this.api.param.GoodInfos = radCargobackup //材积信息集合
        }

      } else if (this.PacketType == 2) {
        this.api.param.Weight = this.docWeightKG || 1
      }


      that.isLoading = true //加载中...
      that.isDataNone = false  //没有数据查无订单
      that.isData = false //有数据列表

      let isGoods = true
      if (this.tempCargo.cargoID == sysCfg.exp.Cargo.generalCargoID) {
        isGoods = false
      } else if (this.tempCargo.cargoID) {
        isGoods = false
      }

      let PacketType = ""
      
      if (this.PacketTypeName(this.PacketType)) {
        PacketType = this.PacketTypeName(this.PacketType)
      }
      console.log("=======this.PacketTypeName(this.PacketType)",this.PacketTypeName(this.PacketType),this.PacketType);

      let cargoArr = []
      if (this.PacketType == 1 && this.goodsInfos) {
        cargoArr = this.goodsInfos.split(',')
      }

      //this.checkPrice('EXPRESS', this.startCityEn, '', this.desCountryEn, '', PacketType, Number(this.api.param.Weight), Number(this.api.param.CBM), Number(this.api.param.Quanlity), isGoods, cargoArr, false, '')


      this.api.url = this.$api04 + "/Express/api/ExpCalculation/QueryPriceEN";
      post(this.api.url, this.api.param).then((res) => {

        let ByPrior = false
        if (res.IsOK == true) {
          if (res.Results.length > 0) {
            ByPrior = res.Results[0].ByPrior
          }
          that.searchResult(res.Total, 'EXPRESS', this.startCityEn, '', this.desCountryEn, '', ByPrior)
        }
        

        if (res.IsOK == true) {
          this.queryDate = JSON.parse(JSON.stringify(this.api.param))
          Generalcargo(that.isNormalGood, 0)
          that.isLoading = false
          that.isData = true
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true
              that.isDataNone != that.isLoading
            } else {
              that.isDataNone = false
            }
          }
        } else {
          that.isLoading = false
          that.isDataNone = true
        }


        that.basicInfo = res.Results;

        //附件费增加数量
        if (that.basicInfo) {
          that.basicInfo.forEach(e => {
            Vue.set(e, 'ieTrue', false) //是否显示费用项列表          
          })
        }
        that.total = res.Total;

        if (that.currentPage == 1) {
          //是否显示查看更多
          if (res.Total > 5) {
            that.isShowMore = true
            that.showData = 5
          } else {
            that.isShowMore = false
          }
        }

        //筛选时效转成数组，去重
        if (res.IsOK && res.Results.length > 0) {
          let array = []
          res.Results.forEach(e => {
            if (e.ThWorkDay > 0) {
              array.push(e.ThWorkDay)
            }
          })
          //数组去重
          let temp = []; //一个新的临时数组
          for (var i = 0; i < array.length; i++) {
            if (temp.indexOf(array[i]) == -1) {
              temp.push(array[i]);
            }
          }
          that.ThWorkDayList = temp
          that.ThWorkDay = that.ThWorkDayList
        } else {
          that.ThWorkDayList = []
        }
      })

    },

    //是否选了木箱单位 
    Iswooned() {
      this.wonned = false
      if (this.QueryType == 2 && this.PacketType == 1) {
        for (let i = 0; i < this.radCargo.length; i++) {
          const ele = this.radCargo[i];
          //console.log(ele)
          if (ele.OrderUnit == 3) {
            this.wonned = true
          }
        }
      }
      if (this.QueryType == 1 && this.PacketType == 1) {
        if (this.unitValue == 3) {
          this.wonned = true
        }
      }
    },

    //--------------------第二部分的方法---------------------//
    //点击编辑订单按钮
    clkEditCond() {
      this.isShowList = false
      this.isShowCond = true
      this.ThWorkDay = []
      bus.$emit('getGeneral')
      console.log("====TypeActived",this.TypeActived);
      //this.TypeActived = 1
      // this.checkIs0Flag = false //将
    },
    //----------------------运输方式-----------------------//
    getModeCodesApi() {
      let that = this;
      //this.api.url = this.$api01 + "/api/InfoCustomer/ModeCode/QueryExpModeCode";
      this.api.url = this.$api04 + "/Express/api/ModeCode/QueryExpModeCode";
      fetch(this.api.url).then(function (res) {
        that.modeCodesItem = res.Results;
        that.modeCodesItem.forEach(e => {
          Vue.set(e, 'isTrue', false)
        })
        //console.log('ss ' + JSON.stringify(that.modeCodesItem))
      })
    },
    //点击全部
    transChkAll() {
      this.chkModeCodes = ['DHL', 'UPS', 'FEDEX', 'TNT', 'EMS', 'DPD',"SF"]
      this.clkEnEnquiryAPI();
    },
    //运输方式值改变
    changeModeCode(value) {
      //console.log('chkModeCodes ' + JSON.stringify(value))
      this.chkModeCodes = value
      this.clkEnEnquiryAPI();
    },
    //仅此点击事件
    onlyTrans(code) {
      this.chkModeCodes = [code]
      this.clkEnEnquiryAPI();
    },
    //查询最便宜的渠道
    // Cheapest() {
    //   this.isSort = 1;
    //   this.Sort = 'amount'
    //   this.currentPage = 1
    //   this.clkEnEnquiryAPI();
    // },
    // //查询最快的渠道
    // Fastest() {
    //   this.isSort = 2;
    //   this.Sort = 'workdays'
    //   this.currentPage = 1
    //   this.clkEnEnquiryAPI();
    // },

    ////排序  综合排序 ：comprehensive  销量排序：expsale 价格排序：price  时效排序：workday
    clkSort(sort) {
      this.orderSort = sort
      this.showData = 20
      this.currentPage = 1
      this.clkEnEnquiryAPI()
    },
    //默认显示5条，分页不显示，点击查看更多，展示一页20条
    clkMore() {
      this.showData = 20
      this.isShowMore = false //是否显示查看更多
    },

    //时效筛选
    chgThkDay(val) {
      //this.ThWorkDay = val
      if (this.ThWorkDay.length > 0) {
        this.isDataNone = false
        this.clkEnEnquiryAPI();
      } else {
        this.isDataNone = true
        this.basicInfo = []
        this.total = 0
      }

    },


    //---------------------快递列表----------------------//
    //点击下拉内容
    clkPriDown(item) {
      item.ieTrue = !item.ieTrue
    },
    //有无电池资料
    //判断是否需要提供电池资料
    //-1：没选择电池；0：不需提供电池资料；1：需要提供电池资料
    isBatteryText(item) {
      // console.log('this.cargoInfoObj.cargoID  ' + JSON.stringify(this.cargoInfoObj.cargoID))
      // console.log('item  ' + JSON.stringify(item))
      let pure = 103; //纯电池ID
      let builtIn = 108; //内置电池ID
      let supporting = 109; //配套电池ID
      //先判断有没有选择电池 -1
      if ($.inArray(pure, this.cargoInfoObj.cargoID) == -1 && $.inArray(builtIn, this.cargoInfoObj.cargoID) == -1 && $.inArray(supporting, this.cargoInfoObj.cargoID) == -1) {
        return -1;
      };


      //判断是否需求提供电池资料
      if (!item.BatteryRequired) {
        return 0;
      }

      let retChk = false; //判断结果
      //电池货要求
      //[{"BatteryType":1,"RequiredInfo":[1],"OtherInfo":null},{"BatteryType":2,"RequiredInfo":[2],"OtherInfo":null},{"BatteryType":3,"RequiredInfo":[3],"OtherInfo":null},{"BatteryType":4,"RequiredInfo":[4],"OtherInfo":"娃哈哈"}]
      let batReq = JSON.parse(item.BatteryRequired);
      batReq.forEach(e => {
        //纯电池
        if (this.isNeedBatDoc(pure, 1, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        //内置电池
        if (this.isNeedBatDoc(builtIn, 2, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        //配套电池
        if (this.isNeedBatDoc(supporting, 3, e) == true) {
          retChk = true;
          return false; //结束循环
        }
        if (this.isNeedBatDoc(supporting, 4, e) == true) {
          retChk = true;
          return false; //结束循环
        }
      });
      // console.log('retChk  ' + retChk)
      return retChk ? 1 : 0;
    },

    //判断是否需要提供电池货资料
    //batID：电池货种类ID
    //batteryType：电池货要求类型
    //batReq：电池货要求
    isNeedBatDoc(batID, batteryType, batReq) {
      if (batReq.BatteryType == batteryType && $.inArray(batID, this.cargoInfoObj.cargoID) >= 0) {
        if (batReq.RequiredInfo.length > 0 && $.inArray(0, batReq.RequiredInfo) < 0) {
          return true;
        }
      }
      return false;
    },
    //点击下单按钮
    clkSelectOrd(item) {
      let that = this;
      // this.api.param=that.EditOrderReqEn
      // this.api.param.OrderProductInfos=that.OrderProductInfos
      this.api.param = {
        ChannelKey: item.ChannelKey,//渠道key
        //渠道返回的城市
        StartCityKey: item.StartCityKey,//起运城市key
        StartCityName: item.StartCityName,//起运城市中文名称
        StartCityNameEn: item.StartCityNameEn,//起运城市英文名称

        DestCountrKey: item.CountryKey,//目的国家key
        DestCountryName: item.CountryName,//目的国家中文名称
        DestCountryNameEn: item.CountryNameEn,//目的国家英文名称
        PackageType: that.PacketType,//包裹类型
        ModeCode: item.ModeCode,//运输方式
        GoodValue: 0,//申报价值
        QueryType: that.QueryType,//按总量还是按单件计算

        Currency: 2,//币种
        IsCopy: false,//是否复制订单
        THChannelKey: item.THChannelKey,//取件渠道key
        THChannelName: item.THChannelName,//取件渠道名称
        FromType: that.FromType,//起始类型。0：工厂，1：百运仓库 ,
        GoodsReadyTime: that.GoodsReadyTime,//货好时间


        QueryStartCityKey: item.QueryStartCityKey,
        QueryStartCityName: item.QueryStartCityName,
        QueryStartCityNameEn: item.QueryStartCityNameEn,
        CountMode: item.CountMode, //计费方式
        PlatformType: 1,//平台类型。0：中文官网，1：英文官网，2：App Android，3：App iOS，4：微信小程序，5：QQ小程序，6：百度小程序，7：字节小程序，8：H5页面，9：平台中心
        OrderWay: 0,//下单方式。0：手动下单、1复制订单、2导入订单、3接口下单
        entrance: "EXPRESS",
        platform_type: "web",
      }
      //console.log(this.api.param,item.QueryStartCityKey,that.startCityKey)
      //运输方式
      // let codeArr=that.chkModeCodes.join(',')
      // this.api.param.ModeCode=codeArr
      //货物种类Id 和 说明
      //console.log(' that.chkModeCodes' +  JSON.stringify(this.cargoInfoObj))

      //下单类型是包裹的时候
      if (that.PacketType == 1) {
        this.api.param.OrderUnit = this.unitValue
        this.api.param.OrderCount = that.allUnits  //下单件数
        this.api.param.OrderWeight = that.allWeight  //下单实重
        this.api.param.OrderVolume = that.allCBM || 0 //下单体积
        //下单材积信息集合 OrderVolumeInfos
        if (that.QueryType == 2) {
          this.api.param.OrderVolumeInfos = that.radCargo
        } else {
          this.api.param.OrderVolumeInfos = []
        }
        this.api.param.VolumeUnit = that.VolumeUnit  //材积单位 新增字段。0：厘米，1：英寸

        let cargoIDArr = that.tempCargo.cargoID.join(',')
        this.api.param.CargoIDs = cargoIDArr
        let cargoInfosArr = that.tempCargo.cargoInfoEn.join(',')
        this.api.param.CargoDescsEn = cargoInfosArr
        let cargoInfosCh = that.tempCargo.carInfoCh.join(',')
        this.api.param.CargoDescs = cargoInfosCh


      } else if (that.PacketType == 2) {
        this.api.param.OrderUnit = 0
        this.api.param.OrderWeight = that.docWeightKG  //下单实重
        this.api.param.VolumeUnit = that.DocUnit  //新增字段。0：厘米，1：英寸
        this.api.param.CargoIDs = ''
        this.api.param.CargoDescs = ''
      }
      ////下单附加费信息
      //this.api.param.OrderExtraFeeInfos=item.FeeInfo,//下单附加费信息
      let FeeInfoArr = []
      item.FeeInfo.forEach(e => {
        let jsonArr = {
          FeeID: e.FeeID,
          FeeName: e.FeeName,
          Price: e.Price,
          Quanlity: e.Quanlity,
          Amount: e.Quanlity * e.Price,
          RelatedService: e.RelatedService,
          FeeSelectType: e.FeeSelectType,
        }
        FeeInfoArr.push(jsonArr)
      })
      this.api.param.OrderExtraFeeInfos = FeeInfoArr,//下单附加费信息

        that.isShowSel = false
      this.api.url = this.$api04 + "/Express/api/ExpNewOrder/AddNotConfirmOrderEn"
      //this.api.url = this.$api03 + "/api/TradeCustomer/ExpNewOrder/AddNotConfirmOrderEn";
      var newWindow = window.open()
      post(this.api.url, this.api.param).then((res) => {
        that.isShowSel = true
        if (res.IsOK == true) {

          let amount = 0
          let TrafficAmount = 0 //运费
          if (item.IsDiscount) {
            amount = item.DiscountAmount
            TrafficAmount = item.DiscountTrafficAmount
          } else {
            amount = item.Amount
            TrafficAmount = item.TrafficAmount
          }

          let KG = 0
          let CBM = 0
          let Unit = 0
          if (that.QueryType == 2) {
            KG = that.sumKG
            CBM = that.sumCBM
            Unit = that.sumUnit
          } else if (that.QueryType == 1) {
            KG = that.inputWeight
            CBM = that.inputCBM
            Unit = that.inputUnits
          }
          // try {
          //   that.submitOrder(res.Results, amount, '', 'EXPRESS', that.startCityEn, '', that.desCountryEn, '', that.goodsInfos,
          //     KG, CBM, Unit, item.ChargeWeight, '', item.ChannelName, TrafficAmount, '', '', false)
          // } catch (err) {
          //   console.warn(err)
          // }

          if (that.$route.query.cargoCode) {
            newWindow.location.href = "/exp/expEdit?ord=" + res.Results + '&cargoCode=' + that.$route.query.cargoCode + '&Qty=' + that.$route.query.Qty
          } else {
            newWindow.location.href = "/exp/expEdit?ord=" + res.Results
          }

        } else if (res.IsOK == false) {
          newWindow.close()
          if (res.Status.Errors.length > 0) {
            let isTrue = true
            res.Status.Errors.forEach(e => {
              if (e.ErrorCode == 'S0001' || e.ErrorCode == 'S0002' || e.ErrorCode == 'S0003' || e.ErrorCode == 'S0004') {
                isTrue = false
              }
            })
            if (isTrue == false) {
              that.$confirm('This channel has expired!', '', {
                customClass: 'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
                showCancelButton: false,//去掉取消按钮
                showClose: false,//去掉右上角的取消（X）
                // type: 'warning',
                center: true
              }).then(() => {

              }).catch(() => {

              });
              return false
            }

          } else {
            that.$confirm('This channel has expired!', '', {
              customClass: 'custom-message-box', //自定义添加Class
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
              closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
              showCancelButton: false,//去掉取消按钮
              showClose: false,//去掉右上角的取消（X）
              // type: 'warning',
              center: true
            }).then(() => {

            }).catch(() => {

            });
            return false
          }
        }
      })
    }
  },

};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/exp/checkExpList.js